import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  moreInfoContainer: {
    backgroundColor: 'white',
    borderRadius: 15,
    elevation: 4,
    padding: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginHorizontal: 10,
    shadowOffset: {width: 2, height: 6},
    shadowColor: '#000000',
    shadowOpacity: 0.1,
    shadowRadius: 16,
  },
});
